"use client";

import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { Control, FieldErrors, UseFormReset, UseFormSetValue } from "react-hook-form";

import { FinanceFormData } from "../schema";
import FormPhoneField from "@/components/common/forms/FormPhoneField";
import FormTextField from "@/components/common/forms/FormTextField";
import { useAuth } from "@/contexts/AuthContext";

interface PersonalInfoStepProps {
  control: Control<FinanceFormData>;
  reset: UseFormReset<FinanceFormData>;
  setValue: UseFormSetValue<FinanceFormData>;
  errors: FieldErrors<FinanceFormData>;
  NextStep: () => void;
  PrevStep: () => void;
  stepIndex: number;
}

const PersonalInfoStep: React.FC<PersonalInfoStepProps> = ({ control, setValue }) => {
  const t = useTranslations("Finance.form.step3");
  const { isAuthLoading, isAuthenticated, user, profile } = useAuth();

  useEffect(() => {
    if (isAuthenticated && profile) {
      setValue("fullName", profile?.name || "");
      setValue("email", profile?.email || "");
      setValue("contactNumber", profile?.phone || "");
    }
  }, [isAuthenticated, profile, setValue]);

  return (
    <div className="mt-10">
      <h4 className="inter mb-6 text-base font-bold">{t("title")}</h4>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FormTextField
          name="fullName"
          control={control}
          placeholder={isAuthLoading ? t("fields.fullName.loading") : t("fields.fullName.placeholder")}
          required
          disabled={isAuthLoading || (isAuthenticated && !!profile?.name)}
          className="h-[60px]"
        />
        <FormTextField
          name="email"
          control={control}
          placeholder={isAuthLoading ? t("fields.fullName.loading") : t("fields.email.placeholder")}
          disabled={isAuthLoading || (isAuthenticated && !!profile?.email)}
          className="h-[60px]"
        />
        <FormPhoneField
          name="contactNumber"
          control={control}
          placeholder={isAuthLoading ? t("fields.fullName.loading") : t("fields.contactNumber.placeholder")}
          required
          disabled={isAuthLoading || (isAuthenticated && !!profile?.phone)}
          className="h-[60px] rtl:placeholder:text-right"
        />
        <FormTextField
          name="currentSalary"
          control={control}
          placeholder={t("fields.currentSalary.placeholder")}
          required
          type="number"
          formatNumber
          inputMode="numeric"
          className="h-[60px]"
        />
      </div>
    </div>
  );
};

export default PersonalInfoStep;
